export default __webpack_public_path__ + "static/B0112-cbe59811d86a2d7be02968069cbd0f92.png";